import { BulkActionBarActions as Qr } from "./actions.js";
import { _ as W } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import { BREAKPOINTS as g, fpds as z } from "@ucl/shared-component-foundations";
import { c as i } from "./index-8b07dec9.js";
import { useRef as R, useMemo as $ } from "react";
import v, { css as f } from "styled-components";
import "./es.object.keys-9d66766f.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import { useSize as j } from "./useSize.js";
import { useSlots as y } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import "./carousel.js";
import { CloseButton as k } from "./closeButton.js";
import "./es.string.trim-6e13db75.js";
import "./index-5d0f31c6.js";
import { jsxs as _, jsx as a } from "react/jsx-runtime";
import "./label.js";
import "./es.array.from-fe752fa6.js";
import "./es.function.name-b230e7d4.js";
import "./index-f5b44da3.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import { Text as S } from "./text.js";
import "./es.date.to-string-6ed49878.js";
import "./export-cdcbfb2b.js";
import "./es.regexp.to-string-e800d529.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./button.js";
import "./combineRefs-c9ad2c39.js";
import "./getMetrics-953aa4f8.js";
import "./iconButton.js";
import "./useContainmentCheck.js";
import "./useResizeObserver.js";
import "./getTarget-19e0f923.js";
import "./isApiSupported-66660265.js";
import "./isClient-2f5bedbd.js";
import "./useIsMounted.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./useEventListener.js";
import "./useOverFlown.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./useMediaQuery.js";
import "./aria.js";
import "./string-trim-14e37ad3.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "@ucl/shared-icons";
import "./popupTip-06ee114c.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./useWindowSize.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.parse-int-d7709701.js";
import "./tooltip.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./uniqueId.js";
import "./es.global-this-a7f40ce1.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.symbol.description-6025a604.js";
import "./es.string.search-d27ec57a.js";
import "./es.function.bind-b4bdcd4b.js";
import "@ucl/ucl-translation";
import "./helperText.js";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./mediaDisclosureButton.js";
import "./index-f2264f1e.js";
import "./screenReaderOnly.js";
import "./accessibility.js";
import "./cloneSlots-622cf8c9.js";
import "./link.js";
import "./badge.js";
import "./es.string.small-23219181.js";
import "./string-html-forced-a746405b.js";
var P = ["count", "title", "onClose", "className", "children"], w = /* @__PURE__ */ v.div.withConfig({
  displayName: "bulkActionBarsummary__StyledSummary",
  componentId: "sc-1h9yaee-0"
})(["&.BulkActionBar__Summary{", "}"], function(r) {
  var t = r.theme.components.bulkActionBar;
  return f(t.Summary);
}), E = /* @__PURE__ */ v.div.withConfig({
  displayName: "bulkActionBarsummary__StyledSummaryTextWrapper",
  componentId: "sc-1h9yaee-1"
})(["&.BulkActionBar__Summary_Title_Wrapper{", "}"], function(r) {
  var t = r.theme.components.bulkActionBar;
  return f(t.StyledSummaryTextWrapper);
}), A = function(t) {
  var l, o, n, s, h = t.count, u = t.title, C = u === void 0 ? "Selected" : u, c = t.onClose, b = t.className, x = t.children, N = W(t, P), m = y(x, {
    CloseButton: A.CloseButton
  }, y.PickType.LAST), p = R(null), e = j((l = p.current) == null ? void 0 : l.parentElement, void 0, "borderBoxSize"), T = $(function() {
    var B;
    return (e == null || (B = e[0]) == null ? void 0 : B.inlineSize) <= g.tabletMin;
  }, [e]), d = (o = p.current) == null || (o = o.nextElementSibling) == null ? void 0 : o.getBoundingClientRect().width;
  return /* @__PURE__ */ _(w, Object.assign({}, N, {
    className: i(["BulkActionBar__Summary", b]),
    ref: p,
    style: {
      width: T ? "calc( 100% - " + z.semantic.space["3x"] + " - " + (d || 40) + "px )" : "50%"
    },
    children: [(c || m.CloseButton) && /* @__PURE__ */ a(k, Object.assign({
      name: "cancelClose",
      onClick: c
    }, (n = m.CloseButton) == null ? void 0 : n.props, {
      className: i(["BulkActionBar__Summary-close-button", (s = m.CloseButton) == null ? void 0 : s.props.className]),
      size: "medium",
      surface: "dark",
      color: "onColor"
    })), /* @__PURE__ */ _(E, {
      className: "BulkActionBar__Summary_Title_Wrapper",
      children: [/* @__PURE__ */ a(S.P, {
        fontWeight: "medium",
        size: "medium",
        className: i(["BulkActionBar__Summary_Title_Wrapper-count"]),
        children: h
      }), /* @__PURE__ */ a(S.P, {
        fontWeight: "medium",
        size: "medium",
        className: i(["BulkActionBar__Summary_Title_Wrapper-label"]),
        children: C
      })]
    })]
  }));
};
A.CloseButton = k;
export {
  Qr as BulkActionBarActions,
  A as BulkActionBarSummary
};
